export const getVppKey = (site) => {
  return {
    "site": site,
    "user": "250804fe-9701-4543-af66-485980a0f369",
    "source": "owner",
    "vpp_platform": "evergen",
    //"active": 1757045447,
    "key": "9876543210987654"
  };
};
